window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('input[data-enable-field]').length) {
    import('./_form-radio-field-enable.js').then((module) => {
      module.Init();
    });
  }
});

export default {};
